import React from 'react'
import {
  SetupHeading,
  InputContainer,
  RadioLabel,
  LabelErrorSpan,
  LangOptionsContainer,
  LoginButton,
} from './styles'
import { Box } from '../../designSystem'
import DropDownSelect from '../../components/GenericDropDownSelect'
import { FloatingInput } from '../FormComponents'
import Loader from '../Loader'

const RegisterPage = ({
  nameMissing,
  fullName,
  handleNameInputChange,
  emailMissing,
  email,
  handleEmailInputChange,
  langPrefMissing,
  langPref,
  updateLangPref,
  referrer,
  hearAboutUs,
  handleHearAboutUs,
  handleRegisterFormSubmit,
  validateFields,
  isRegisterProcessing,
}) => {
  return (
    <>
      <SetupHeading>Set up your Pocket Novels Writers Account !</SetupHeading>

      <Box mb={16}>
        <FloatingInput
          error={nameMissing}
          type="text"
          name="full-name"
          label="Your Name"
          value={fullName}
          onChange={(text) => handleNameInputChange(text)}
        />
      </Box>

      <Box mb={16}>
        <FloatingInput
          error={emailMissing}
          type="text"
          name="email"
          label="Your Email"
          value={email}
          onChange={(text) => handleEmailInputChange(text)}
        />
      </Box>
      <InputContainer>
        <RadioLabel invalid={langPrefMissing}>
          Language Proficiency{' '}
          {langPrefMissing && <LabelErrorSpan> - required</LabelErrorSpan>}
        </RadioLabel>
        <LangOptionsContainer>
          <DropDownSelect
            name="langPref"
            placeholder="Click to select language"
            selectOptions={[
              { id: 1, name: 'hindi' },
              { id: 2, name: 'tamil' },
              { id: 3, name: 'bengali' },
              { id: 4, name: 'malayalam' },
              { id: 5, name: 'telugu' },
              { id: 6, name: 'marathi' },
              { id: 7, name: 'kannada' },
              { id: 8, name: 'english' },
              { id: 9, name: 'odia' },
              { id: 10, name: 'gujarati' },
            ]}
            idKey="name"
            nameKey="name"
            value={langPref}
            onChange={(language) => updateLangPref(language)}
          />
        </LangOptionsContainer>
      </InputContainer>
      {!referrer && (
        <Box mb={16}>
          <FloatingInput
            type="text"
            name="hearAboutUs"
            label="Where did you hear about us ?"
            value={hearAboutUs}
            onChange={(text) => handleHearAboutUs(text)}
          />
        </Box>
      )}
      <LoginButton
        onClick={handleRegisterFormSubmit}
        disabled={!validateFields()}
      >
        {isRegisterProcessing ? (
          <Loader size="sm" invertColor noPadding />
        ) : (
          'continue'
        )}
      </LoginButton>
    </>
  )
}

export default RegisterPage
